
/*
=========================================================================================
AUTO GENERATED
=========================================================================================
Date:       2021-06-18 17:26:07.787
From:       BADGER\SQL2016 - qmuzik_metabase
Comment:    Any manual changes to this file will be overwritten. Any changes to rules 
            should be made in the metabase. Then this file should be re-generated.
=========================================================================================*/

import { ViewState, ValidationError, Rules } from "qmuzik-angular-model-core";
import { Rule } from "qmuzik-angular-model-core";

//=======================================================================================
// Rules
//=======================================================================================
export function BuildRules(modelState: boolean, viewState: boolean): Rules{
    let rules = new Rules();
    let rule: Rule;

    return rules;
}
 
